import { render, staticRenderFns } from "./Progreso.vue?vue&type=template&id=5baffd7a&"
import script from "./Progreso.vue?vue&type=script&lang=js&"
export * from "./Progreso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports